import React, { useRef } from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import MechaWeaponStore from '@src/pages/mecha/sections/weapon/store';
import Link from '@src/components/link';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import Toast from '@src/components/toast';
import rootStore from '@src/mobx-store/root-store';
import Message from '@src/components/common-message';
const { globalStore } = rootStore;

const MechaWeapon = ({ store }) => {
  store.use();

  const videoRef = useRef(null);
  const onPlayVideo = src => {
    if (src) {
      store.isPlayingCurrentVideo = true;

      // 获取 video 元素并播放
      if (videoRef.current) {
        videoRef.current.play();
      }
    } else {
      Toast.info(getLocales('global.comming_soon'));
    }
  };

  const handleVideoEnded = e => {
    // 关闭视频后，如果背景音乐最近一次有播放，则继续播放
    globalStore.toggleBgmState(globalStore.lastBgmState);
    e.target.controls = false;
    store.isPlayingCurrentVideo = false;
  };

  const controlVideo = isPlay => {
    const video = videoRef.current;
    video.addEventListener('ended', handleVideoEnded);
    if (video) {
      if (isPlay) {
        video.currentTime = 0;
        video.controls = true;
        // 视频播放时，关闭背景音乐
        globalStore.recordLastBgmState();
        globalStore.toggleBgmState(false);
        video.play();
      } else {
        // 关闭视频后，如果背景音乐最近一次有播放，则继续播放
        globalStore.toggleBgmState(globalStore.lastBgmState);
        video.removeEventListener('ended', handleVideoEnded);
        video.pause();
      }
    }
  };

  React.useEffect(
    () => {
      const handleScroll = () => {
        const weaponElement = document.getElementById('mecha-weapon');
        if (weaponElement) {
          const rect = weaponElement.getBoundingClientRect();
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (isVisible && !store.isActive) {
            store.isActive = true;
          }
        }
      };

      window.addEventListener('scroll', handleScroll);
      handleScroll();

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    },
    [store.isActive]
  );

  /**
   * 渲染武器按钮
   * @param item
   * @param index
   * @returns {JSX.Element}
   */
  const renderTabBtn = (item, index) => {
    const isActive = store?.currentWeaponId === index;
    return (
      <div key={index} className={cx(styles.listBox, isActive && styles.listBox_actives)} onClick={() => store.onChangeWeaponSwiper(index)}>
        {isActive && <div className={styles.activeBox} />}
        <img src={item?.armed_icon} alt="" />
      </div>
    );
  };

  const renderWrapText = text => {
    if (!text) return null;

    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <div className={cx(styles.mechaWeaponRoot)} id="mecha-weapon">
      {store?.isActive && (
        <div className={styles.mecha_group_1}>
          <div className={styles.mecha_layer_line} />
          <div className={styles.mecha_group_2}>
            {store?.weaponMsgList.length > 0 &&
              store?.weaponMsgList.map((item, index) => {
                return renderTabBtn(item, index);
              })}
          </div>

          <div className={cx(styles.mecha_panel, store?.initSwiperState && styles.mecha_panel_actives)}>
            {store?.weaponMsgList &&
              store?.weaponMsgList.length > 0 && (
                <BaseSwiper key={store?.currentMechaMsgId} store={store?.weaponSwiper}>
                  {store?.weaponMsgList?.map((item, index) => {
                    return (
                      <div key={index} className={styles.panelBox}>
                        <div className={styles.contentName}>{item?.weapon_name}</div>
                        <div className={styles.shortDesc}>{renderWrapText(item?.short_desc)}</div>
                        <div className={styles.contentDesc}>{renderWrapText(item?.desc)}</div>
                        {/* <div className={styles.contentImage} style={{ backgroundImage: `url(${item?.detail_bg_text})` }} /> */}
                      </div>
                    );
                  })}
                </BaseSwiper>
              )}
          </div>
          <div className={styles.video}>
            <div className={styles.video_box} />
            <div className={styles.videoContaintr}>
              {!store?.isPlayingCurrentVideo && (
                <div>
                  <div
                    className={styles.layer_video}
                    style={{
                      backgroundImage: `url(${store?.weaponMsgList[store.currentWeaponId]?.video_cover})`
                    }}
                  />
                  <div
                    data-btn-hover
                    className={styles.videoPlay}
                    onClick={() => {
                      if (!store?.weaponMsgList[store.currentWeaponId]?.video_url) {
                        Message.info(getLocales('global.comming_soon'));
                        return;
                      }
                      onPlayVideo(store.weaponMsgList[store.currentWeaponId].video_url);
                      controlVideo(true);
                    }}
                  />
                </div>
              )}
              <video ref={videoRef} className={styles.play_video} src={store?.weaponMsgList[store.currentWeaponId]?.video_url} controls />
            </div>
          </div>
          <Link className={styles.videoBtn}>
            <div className={styles.videoIcon}>{store?.weaponMsgList[store.currentWeaponId]?.weapon_typt}</div>
          </Link>
        </div>
      )}
    </div>
  );
};

export default wrapStore(MechaWeapon, MechaWeaponStore);
